import React, { Component, useEffect, useState } from "react";

//custom
import { Link } from "react-router-dom";
import axios from "axios";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

//assests
import logo_header from "../../assests/images/logo_header.jpg";
//navigation icon
import course from "../../assests/images/navigation/course.png";
import course_active from "../../assests/images/navigation/course_active.png";
import myprofile from "../../assests/images/navigation/myprofile.png";
import myprofile_active from "../../assests/images/navigation/myprofile_active.png";

function Header(props) {
  //app_history to useNavigate
  const app_history = useNavigate();

  //props
  const { link_type } = props;

  //navigation variable
  const [list_temp_load, set_list_temp_load] = useState([]);

  //link ariable
  const [nav_home, set_nav_home] = useState(course);
  const [nav_myprofile, set_nav_myprofile] = useState(myprofile);

  //use effect to load first
  //first time ui load
  useEffect(() => {
    //set navigation UI
    set_navigation_ui();
  }, [list_temp_load]);

  //set_navigation_ui
  function set_navigation_ui() {
    if (link_type == "home") {
      set_nav_home(course_active);
    }
    if (link_type == "myprofile") {
      set_nav_myprofile(myprofile_active);
    }
  }

  return (
    <React.Fragment>
      <div className="header_app z-depth-1">
        <div className="container">
          <div className="row">
            <div className="col s12">
              <center>
                <Link to={"/home"}>
                  <img src={logo_header} className="header_logo" />
                </Link>
              </center>
            </div>
            <div className="col s12">
              <i
                className={
                  "fa fa-arrow-left back_icon left " +
                  (link_type == "home" ? "hide" : "")
                }
                onClick={() => app_history(-1)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="navigation z-depth-1">
        <div className="container">
          <div className="row">
            <div className="col s6 nav_row_col center">
              <Link to={"/home"}>
                <img src={nav_home} className="nav_image_footer" />
                <div className="div_text_footer">
                  <font
                    className={
                      link_type == "home"
                        ? "nav_text_footer_active"
                        : "nav_text_footer"
                    }
                  >
                    Course
                  </font>
                </div>
              </Link>
            </div>
            <div className="col s6 nav_row_col center">
              <Link to={"/myprofile"}>
                <img src={nav_myprofile} className="nav_image_footer" />
                <div className="div_text_footer">
                  <font
                    className={
                      link_type == "myprofile"
                        ? "nav_text_footer_active"
                        : "nav_text_footer"
                    }
                  >
                    Profile
                  </font>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Header;
